var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientReportBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2039_3529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.666 8.00065H15.9993L14.1193 6.12065C13.6127 5.61398 12.9327 5.33398 12.226 5.33398H5.33268C3.86602 5.33398 2.67935 6.53398 2.67935 8.00065L2.66602 24.0007C2.66602 25.4673 3.86602 26.6673 5.33268 26.6673H26.666C28.1327 26.6673 29.3327 25.4673 29.3327 24.0007V10.6673C29.3327 9.20065 28.1327 8.00065 26.666 8.00065ZM19.9993 12.0007C21.466 12.0007 22.666 13.2007 22.666 14.6673C22.666 16.134 21.466 17.334 19.9993 17.334C18.5327 17.334 17.3327 16.134 17.3327 14.6673C17.3327 13.2007 18.5327 12.0007 19.9993 12.0007ZM25.3327 22.6673H14.666V21.334C14.666 19.5606 18.226 18.6673 19.9993 18.6673C21.7727 18.6673 25.3327 19.5606 25.3327 21.334V22.6673Z",
    fill: "#5F6CE1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2039_3529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientReportBlue);
export default __webpack_public_path__ + "static/media/clientReportBlue.04406a84668e602b8ffb7d7a9b0541ef.svg";
export { ForwardRef as ReactComponent };